import { computed } from "vue";
import { usePermissions } from "./usePermissions";

// Rôles habilités à voir/accéder à l'Assistant IA
export const ASSISTANT_ROLES = ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"];

export function useAssistantAccess() {
  const { hasRole } = usePermissions();
  const canAccessAssistant = computed(() => hasRole(ASSISTANT_ROLES));
  return { canAccessAssistant };
}
